import { render, staticRenderFns } from "./tax-form.vue?vue&type=template&id=c4db79d2"
import script from "./tax-form.vue?vue&type=script&lang=js"
export * from "./tax-form.vue?vue&type=script&lang=js"
import style0 from "./tax-form.vue?vue&type=style&index=0&id=c4db79d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports